import main from '../views/main/index.vue';

const RouteView = {
  name: 'RouteView',
  render: h => h('router-view')
};

export default [
  {
    path: '/',
    component: main,
    meta: {
      title: '默认页',
      requireAuth: false,
      hideInMenu: true
    }
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      icon: 'ios-settings',
      hideInMenu: true,
      title: '登录页',
      requireAuth: false //表示当前响应的请求是否需要进行登录拦截验证【true：需要；false：不需要】
    },
    component: resolve => {
      require(['../views/login/login.vue'], resolve);
    }
  },
  {
    path: '/forgetPassword',
    name: 'forgetPassword',
    meta: {
      icon: 'ios-settings',
      hideInMenu: true,
      title: '忘记密码页',
      requireAuth: false //表示当前响应的请求是否需要进行登录拦截验证【true：需要；false：不需要】
    },
    component: resolve => {
      require(['../views/login/forgetPassword.vue'], resolve);
    }
  },
  {
    path: '/register',
    name: 'register',
    redirect: '/login',
    meta: {
      icon: 'ios-settings',
      hideInMenu: true,
      title: '注册页',
      requireAuth: false //表示当前响应的请求是否需要进行登录拦截验证【true：需要；false：不需要】
    }
  },
  {
    path: '/404',
    name: 'NotFound',
    meta: {
      icon: 'warning',
      hideInMenu: true,
      title: '页面不存在',
      requireAuth: false
    },
    component: resolve => {
      require(['../views/error/404/index.vue'], resolve);
    }
  },
  {
    path: '/base',
    name: 'Base',
    component: main,
    meta: {
      icon: 'database',
      title: '基础信息',
      code: 'base',
      requireAuth: true
    },
    children: [
      {
        path: 'subject',
        name: 'BaseSubject',
        meta: {
          icon: 'bank',
          title: '主体信息',
          code: 'base-subject',
          requireAuth: true,
          cacheName: 'BaseSubject'
        },
        component: resolve => {
          require(['../views/base/subject/index.vue'], resolve);
        }
      },
      {
        path: 'subject/campus/create',
        name: 'BaseSubjectCampusCreate',
        meta: {
          icon: 'plus',
          title: '新增校区信息',
          code: 'base-subject-campus-create',
          requireAuth: true,
          keepAlive: false,
          hideInMenu: true,
          activeMenu: 'BaseSubject'
        },
        component: resolve => {
          require(['../views/base/subject/campus-form/index.vue'], resolve);
        }
      },
      {
        path: 'subject/campus/:id/edit',
        name: 'BaseSubjectCampusEdit',
        meta: {
          icon: 'edit',
          title: '编辑校区信息',
          code: 'base-subject-campus-edit',
          requireAuth: true,
          keepAlive: false,
          hideInMenu: true,
          activeMenu: 'BaseSubject'
        },
        component: resolve => {
          require(['../views/base/subject/campus-form/index.vue'], resolve);
        }
      },
      {
        path: 'canteen',
        name: 'BaseCanteen',
        meta: {
          icon: 'shop',
          title: '食堂信息',
          code: 'base-canteen',
          requireAuth: true
        },
        component: resolve => {
          require(['../views/base/canteen/index.vue'], resolve);
        }
      },
      {
        path: 'canteen/create',
        name: 'BaseCanteenCreate',
        meta: {
          icon: 'plus',
          title: '新增食堂信息',
          code: 'base-canteen-create',
          requireAuth: true,
          keepAlive: false,
          hideInMenu: true,
          activeMenu: 'BaseCanteen'
        },
        component: resolve => {
          require(['../views/base/canteen/canteen-form/index.vue'], resolve);
        }
      },
      {
        path: 'canteen/:id/edit',
        name: 'BaseCanteenEdit',
        meta: {
          icon: 'edit',
          title: '编辑食堂信息',
          code: 'base-canteen-edit',
          requireAuth: true,
          keepAlive: false,
          hideInMenu: true,
          activeMenu: 'BaseCanteen'
        },
        component: resolve => {
          require(['../views/base/canteen/canteen-form/index.vue'], resolve);
        }
      },
      {
        path: 'staff',
        name: 'BaseStaff',
        meta: {
          icon: 'team',
          title: '员工信息',
          code: 'base-staff',
          requireAuth: true
        },
        component: resolve => {
          require(['../views/base/staff/index.vue'], resolve);
        }
      },
      {
        path: 'staff/create',
        name: 'BaseStaffCreate',
        meta: {
          icon: 'plus',
          title: '新增员工信息',
          code: 'base-staff-create',
          requireAuth: true,
          keepAlive: false,
          hideInMenu: true,
          activeMenu: 'BaseStaff'
        },
        component: resolve => {
          require(['../views/base/staff/staff-form/index.vue'], resolve);
        }
      },
      {
        path: 'staff/:id/edit',
        name: 'BaseStaffEdit',
        meta: {
          icon: 'edit',
          title: '编辑员工信息',
          code: 'base-staff-edit',
          requireAuth: true,
          keepAlive: false,
          hideInMenu: true,
          activeMenu: 'BaseStaff'
        },
        component: resolve => {
          require(['../views/base/staff/staff-form/index.vue'], resolve);
        }
      },
      {
        path: 'cateringUnit',
        name: 'BaseCateringUnit',
        meta: {
          icon: 'home',
          title: '供餐单位',
          code: 'base-catering-unit',
          requireAuth: true
        },
        component: resolve => {
          require(['../views/base/catering-unit/index.vue'], resolve);
        }
      },
      {
        path: 'cateringUnit/create',
        name: 'BaseCateringUnitCreate',
        meta: {
          icon: 'plus',
          title: '新增供餐单位',
          code: 'base-catering-unit-create',
          requireAuth: true,
          keepAlive: false,
          hideInMenu: true,
          activeMenu: 'BaseCateringUnit'
        },
        component: resolve => {
          require(['../views/base/catering-unit/catering-unit-form/index.vue'], resolve);
        }
      },
      {
        path: 'cateringUnit/:id/edit',
        name: 'BaseCateringUnitEdit',
        meta: {
          icon: 'edit',
          title: '编辑供餐单位',
          code: 'base-catering-unit-edit',
          requireAuth: true,
          keepAlive: false,
          hideInMenu: true,
          activeMenu: 'BaseCateringUnit'
        },
        component: resolve => {
          require(['../views/base/catering-unit/catering-unit-form/index.vue'], resolve);
        }
      },
      {
        path: 'deliveryUnit',
        name: 'BaseDeliveryUnit',
        meta: {
          icon: 'car',
          title: '配送单位',
          code: 'base-delivery-unit',
          requireAuth: true
        },
        component: resolve => {
          require(['../views/base/delivery-unit/index.vue'], resolve);
        }
      },
      {
        path: 'deliveryUnit/create',
        name: 'BaseDeliveryUnitCreate',
        meta: {
          icon: 'plus',
          title: '新增配送单位',
          code: 'base-delivery-unit-create',
          requireAuth: true,
          keepAlive: false,
          hideInMenu: true,
          activeMenu: 'BaseDeliveryUnit'
        },
        component: resolve => {
          require(['../views/base/delivery-unit/delivery-unit-form/index.vue'], resolve);
        }
      },
      {
        path: 'deliveryUnit/:id/edit',
        name: 'BaseDeliveryUnitEdit',
        meta: {
          icon: 'edit',
          title: '编辑配送单位',
          code: 'base-delivery-unit-edit',
          requireAuth: true,
          keepAlive: false,
          hideInMenu: true,
          activeMenu: 'BaseDeliveryUnit'
        },
        component: resolve => {
          require(['../views/base/delivery-unit/delivery-unit-form/index.vue'], resolve);
        }
      },
      {
        path: 'deliveryUnit/:id/detail',
        name: 'BaseDeliveryUnitDetail',
        meta: {
          icon: 'profile',
          title: '配送单位详情',
          code: 'base-delivery-unit-detail',
          requireAuth: true,
          keepAlive: false,
          hideInMenu: true,
          activeMenu: 'BaseDeliveryUnit'
        },
        component: resolve => {
          require(['../views/base/delivery-unit/delivery-unit-detail/index.vue'], resolve);
        }
      }
    ]
  },
  {
    path: '/meal',
    name: 'Meal',
    component: main,
    meta: {
      icon: 'shopping',
      title: '用餐消费',
      code: 'meal',
      requireAuth: true
    },
    children: [
      {
        path: 'dishes',
        name: 'MealDishes',
        meta: {
          icon: 'appstore',
          title: '菜品库',
          code: 'meal-dishes',
          requireAuth: true
        },
        component: resolve => {
          require(['../views/meal/dishes/index.vue'], resolve);
        }
      },
      {
        path: 'dishes/create',
        name: 'MealDishesCreate',
        meta: {
          title: '新增菜品',
          code: 'meal-dishes-create',
          requireAuth: true,
          hideInMenu: true,
          activeMenu: 'MealDishes',
          keepAlive: false,
          formMode: 'create'
        },
        component: resolve => {
          require(['../views/meal/dishes/dishes-form/index.vue'], resolve);
        }
      },
      {
        path: 'dishes/edit/:id',
        name: 'MealDishesEdit',
        meta: {
          title: '编辑菜品',
          code: 'meal-dishes-edit',
          requireAuth: true,
          hideInMenu: true,
          activeMenu: 'MealDishes',
          keepAlive: false,
          formMode: 'edit'
        },
        component: resolve => {
          require(['../views/meal/dishes/dishes-form/index.vue'], resolve);
        }
      },
      {
        path: 'dishes/detail/:id',
        name: 'MealDishesDetail',
        meta: {
          title: '菜品详情',
          code: 'meal-dishes-detail',
          requireAuth: true,
          hideInMenu: true,
          activeMenu: 'MealDishes',
          keepAlive: false
        },
        component: resolve => {
          require(['../views/meal/dishes/dishes-detail/index.vue'], resolve);
        }
      },
      {
        path: 'packages',
        name: 'MealPackages',
        meta: {
          icon: 'profile',
          title: '套餐信息',
          code: 'meal-packages',
          requireAuth: true
        },
        component: resolve => {
          require(['../views/meal/packages/index.vue'], resolve);
        }
      },
      {
        path: 'packages/create',
        name: 'MealPackagesCreate',
        meta: {
          title: '新增套餐',
          code: 'meal-packages-create',
          requireAuth: true,
          hideInMenu: true,
          activeMenu: 'MealPackages',
          keepAlive: false,
          formMode: 'create'
        },
        component: resolve => {
          require(['../views/meal/packages/packages-form/index.vue'], resolve);
        }
      },
      {
        path: 'packages/edit/:id',
        name: 'MealPackagesEdit',
        meta: {
          title: '编辑套餐',
          code: 'meal-packages-edit',
          requireAuth: true,
          hideInMenu: true,
          activeMenu: 'MealPackages',
          keepAlive: false,
          formMode: 'edit'
        },
        component: resolve => {
          require(['../views/meal/packages/packages-form/index.vue'], resolve);
        }
      },
      {
        path: 'recipes',
        name: 'MealRecipes',
        meta: {
          icon: 'read',
          title: '每日食谱',
          code: 'meal-recipes',
          requireAuth: true
        },
        component: resolve => {
          require(['../views/meal/recipes/index.vue'], resolve);
        }
      },
      {
        path: 'recipes/create',
        name: 'MealRecipesCreate',
        meta: {
          title: '新增每日食谱',
          code: 'meal-recipes-create',
          requireAuth: true,
          hideInMenu: true,
          activeMenu: 'MealRecipes',
          keepAlive: false,
          formMode: 'create'
        },
        component: resolve => {
          require(['../views/meal/recipes/recipes-form/index.vue'], resolve);
        }
      },
      {
        path: 'recipes/edit/:id',
        name: 'MealRecipesEdit',
        meta: {
          title: '编辑每日食谱',
          code: 'meal-recipes-edit',
          requireAuth: true,
          hideInMenu: true,
          activeMenu: 'MealRecipes',
          keepAlive: false,
          formMode: 'edit'
        },
        component: resolve => {
          require(['../views/meal/recipes/recipes-form/index.vue'], resolve);
        }
      },
      {
        path: 'recipes/detail/:id',
        name: 'MealRecipesDetail',
        meta: {
          title: '每日食谱详情',
          code: 'meal-recipes-detail',
          requireAuth: true,
          hideInMenu: true,
          activeMenu: 'MealRecipes',
          keepAlive: false
        },
        component: resolve => {
          require(['../views/meal/recipes/recipes-detail/index.vue'], resolve);
        }
      },
      {
        path: 'satisfaction',
        name: 'MealSatisfaction',
        meta: {
          icon: 'smile',
          title: '满意度',
          code: 'meal-satisfaction',
          requireAuth: true
        },
        component: resolve => {
          require(['../views/meal/satisfaction/index.vue'], resolve);
        }
      },
      {
        path: 'satisfaction/create',
        name: 'MealSatisfactionCreate',
        meta: {
          title: '新增满意度',
          code: 'meal-satisfaction-create',
          requireAuth: true,
          hideInMenu: true,
          activeMenu: 'MealSatisfaction',
          keepAlive: false,
          formMode: 'create'
        },
        component: resolve => {
          require(['../views/meal/satisfaction/satisfaction-form/index.vue'], resolve);
        }
      },
      {
        path: 'satisfaction/edit/:id',
        name: 'MealSatisfactionEdit',
        meta: {
          title: '编辑满意度',
          code: 'meal-satisfaction-edit',
          requireAuth: true,
          hideInMenu: true,
          activeMenu: 'MealSatisfaction',
          keepAlive: false,
          formMode: 'edit'
        },
        component: resolve => {
          require(['../views/meal/satisfaction/satisfaction-form/index.vue'], resolve);
        }
      },
      {
        path: 'satisfaction/detail/:id',
        name: 'MealSatisfactionDetail',
        meta: {
          title: '满意度详情',
          code: 'meal-satisfaction-detail',
          requireAuth: true,
          hideInMenu: true,
          activeMenu: 'MealSatisfaction',
          keepAlive: false
        },
        component: resolve => {
          require(['../views/meal/satisfaction/satisfaction-detail/index.vue'], resolve);
        }
      },
      {
        path: 'recharges',
        name: 'MealRecharges',
        meta: {
          icon: 'pay-circle',
          title: '充值记录',
          code: 'meal-recharges',
          requireAuth: true
        },
        component: resolve => {
          require(['../views/meal/recharges/index.vue'], resolve);
        }
      },
      {
        path: 'recharges/create',
        name: 'MealRechargesCreate',
        meta: {
          title: '新增充值记录',
          code: 'meal-recharges-create',
          requireAuth: true,
          hideInMenu: true,
          activeMenu: 'MealRecharges',
          formMode: 'create',
          keepAlive: false
        },
        component: resolve => {
          require(['../views/meal/recharges/recharges-form/index.vue'], resolve);
        }
      },
      {
        path: 'recharges/edit/:id',
        name: 'MealRechargesEdit',
        meta: {
          title: '编辑充值记录',
          code: 'meal-recharges-edit',
          requireAuth: true,
          hideInMenu: true,
          activeMenu: 'MealRecharges',
          formMode: 'edit',
          keepAlive: false
        },
        component: resolve => {
          require(['../views/meal/recharges/recharges-form/index.vue'], resolve);
        }
      },
      {
        path: 'consumption',
        name: 'MealConsumption',
        meta: {
          icon: 'shopping-cart',
          title: '消费记录',
          code: 'meal-consumption',
          requireAuth: true
        },
        component: resolve => {
          require(['../views/meal/consumption/index.vue'], resolve);
        }
      },
      {
        path: 'consumption/create',
        name: 'MealConsumptionCreate',
        meta: {
          title: '新增消费记录',
          code: 'meal-consumption-create',
          requireAuth: true,
          hideInMenu: true,
          activeMenu: 'MealConsumption',
          keepAlive: false
        },
        component: resolve => {
          require(['../views/meal/consumption/consumption-create/index.vue'], resolve);
        }
      },
      {
        path: 'consumption/edit/:id',
        name: 'MealConsumptionEdit',
        meta: {
          title: '编辑消费记录',
          code: 'meal-consumption-edit',
          requireAuth: true,
          hideInMenu: true,
          activeMenu: 'MealConsumption',
          keepAlive: false
        },
        component: resolve => {
          require(['../views/meal/consumption/consumption-edit/index.vue'], resolve);
        }
      },
    ]
  },
  {
    path: '/purchase',
    name: 'Purchase',
    component: main,
    meta: {
      icon: 'shopping-cart',
      title: '采购验收',
      code: 'purchase',
      requireAuth: true
    },
    children: [
      {
        path: 'ingredients',
        name: 'PurchaseIngredients',
        meta: {
          icon: 'appstore',
          title: '食材信息',
          code: 'purchase-ingredients',
          requireAuth: true
        },
        component: resolve => {
          require(['../views/purchase/ingredients/index.vue'], resolve);
        }
      },
      {
        path: 'orders',
        name: 'PurchaseOrders',
        meta: {
          icon: 'ordered-list',
          title: '采购订单',
          code: 'purchase-orders',
          requireAuth: true
        },
        component: resolve => {
          require(['../views/purchase/orders/index.vue'], resolve);
        }
      },
      {
        path: 'orders/:id/detail',
        name: 'PurchaseOrdersDetail',
        meta: {
          icon: 'profile',
          title: '采购订单详情',
          code: 'purchase-orders-detail',
          requireAuth: true,
          keepAlive: false,
          hideInMenu: true,
          activeMenu: 'PurchaseOrders'
        },
        component: resolve => {
          require(['../views/purchase/orders/orders-detail/index.vue'], resolve);
        }
      },
      {
        path: 'acceptance',
        name: 'PurchaseAcceptance',
        meta: {
          icon: 'check-square',
          title: '验收信息',
          code: 'purchase-acceptance',
          requireAuth: true
        },
        component: resolve => {
          require(['../views/purchase/acceptance/index.vue'], resolve);
        }
      },
      {
        path: 'acceptance/:id/detail',
        name: 'PurchaseAcceptanceDetail',
        meta: {
          icon: 'profile',
          title: '验收信息详情',
          code: 'purchase-acceptance-detail',
          requireAuth: true,
          keepAlive: false,
          hideInMenu: true,
          activeMenu: 'PurchaseAcceptance'
        },
        component: resolve => {
          require(['../views/purchase/acceptance/acceptance-detail/index.vue'], resolve);
        }
      }
    ]
  },
  {
    path: '/stock',
    name: 'Stock',
    component: main,
    meta: {
      icon: 'inbox',
      title: '库存信息',
      code: 'stock',
      requireAuth: true
    },
    children: [
      {
        path: 'inbound',
        name: 'StockInbound',
        meta: {
          icon: 'download',
          title: '入库信息',
          code: 'stock-inbound',
          requireAuth: true
        },
        component: resolve => {
          require(['../views/stock/inbound/index.vue'], resolve);
        }
      },
      {
        path: 'inbound/:id/detail',
        name: 'StockInboundDetail',
        meta: {
          icon: 'profile',
          title: '入库详情',
          code: 'stock-inbound-detail',
          requireAuth: true,
          keepAlive: false,
          hideInMenu: true,
          activeMenu: 'StockInbound'
        },
        component: resolve => {
          require(['../views/stock/inbound/inbound-detail/index.vue'], resolve);
        }
      },
      {
        path: 'outbound',
        name: 'StockOutbound',
        meta: {
          icon: 'upload',
          title: '出库信息',
          code: 'stock-outbound',
          requireAuth: true
        },
        component: resolve => {
          require(['../views/stock/outbound/index.vue'], resolve);
        }
      },
      {
        path: 'outbound/:id/detail',
        name: 'StockOutboundDetail',
        meta: {
          icon: 'profile',
          title: '出库详情',
          code: 'stock-outbound-detail',
          requireAuth: true,
          keepAlive: false,
          hideInMenu: true,
          activeMenu: 'StockOutbound'
        },
        component: resolve => {
          require(['../views/stock/outbound/outbound-detail/index.vue'], resolve);
        }
      },
      {
        path: 'inventory',
        name: 'StockInventory',
        meta: {
          icon: 'audit',
          title: '盘存信息',
          code: 'stock-inventory',
          requireAuth: true
        },
        component: resolve => {
          require(['../views/stock/inventory/index.vue'], resolve);
        }
      },
      {
        path: 'inventory/create',
        name: 'StockInventoryCreate',
        meta: {
          icon: 'plus',
          title: '新增商品盘存信息',
          code: 'stock-inventory-create',
          requireAuth: true,
          keepAlive: false,
          hideInMenu: true,
          activeMenu: 'StockInventory',
          formMode: 'create'
        },
        component: resolve => {
          require(['../views/stock/inventory/inventory-form/index.vue'], resolve);
        }
      },
      {
        path: 'inventory/:id/edit',
        name: 'StockInventoryEdit',
        meta: {
          icon: 'edit',
          title: '修改商品盘存信息',
          code: 'stock-inventory-edit',
          requireAuth: true,
          keepAlive: false,
          hideInMenu: true,
          activeMenu: 'StockInventory',
          formMode: 'edit'
        },
        component: resolve => {
          require(['../views/stock/inventory/inventory-form/index.vue'], resolve);
        }
      }
    ]
  },
  {
    path: '/finance',
    name: 'Finance',
    component: main,
    meta: {
      icon: 'wallet',
      title: '财务结算',
      code: 'finance',
      requireAuth: true
    },
    children: [
      {
        path: 'selfSupportIncome',
        name: 'FinanceSelfSupportIncome',
        meta: {
          icon: 'account-book',
          title: '自营食堂收支',
          code: 'finance-self-support-income',
          requireAuth: true
        },
        component: resolve => {
          require(['../views/finance/self-support-income/index.vue'], resolve);
        }
      },
      {
        path: 'selfSupportIncome/create',
        name: 'FinanceSelfSupportIncomeCreate',
        meta: {
          title: '新增自营食堂收支',
          code: 'finance-self-support-income-create',
          requireAuth: true,
          hideInMenu: true,
          activeMenu: 'FinanceSelfSupportIncome',
          keepAlive: false,
          formMode: 'create'
        },
        component: resolve => {
          require(['../views/finance/self-support-income/income-form/index.vue'], resolve);
        }
      },
      {
        path: 'selfSupportIncome/edit/:id',
        name: 'FinanceSelfSupportIncomeEdit',
        meta: {
          title: '修改自营食堂收支',
          code: 'finance-self-support-income-edit',
          requireAuth: true,
          hideInMenu: true,
          activeMenu: 'FinanceSelfSupportIncome',
          keepAlive: false,
          formMode: 'edit'
        },
        component: resolve => {
          require(['../views/finance/self-support-income/income-form/index.vue'], resolve);
        }
      },
      {
        path: 'selfSupportIncome/detail/:id',
        name: 'FinanceSelfSupportIncomeDetail',
        meta: {
          title: '食堂收支详情',
          code: 'finance-self-support-income-detail',
          requireAuth: true,
          hideInMenu: true,
          activeMenu: 'FinanceSelfSupportIncome',
          keepAlive: false
        },
        component: resolve => {
          require(['../views/finance/self-support-income/income-detail/index.vue'], resolve);
        }
      },
      {
        path: 'selfSupportFlow',
        name: 'FinanceSelfSupportFlow',
        meta: {
          icon: 'transaction',
          title: '自营食堂流水',
          code: 'finance-self-support-flow',
          requireAuth: true
        },
        component: resolve => {
          require(['../views/finance/self-support-flow/index.vue'], resolve);
        }
      },
      {
        path: 'nonSelfSupportIncome',
        name: 'FinanceNonSelfSupportIncome',
        meta: {
          icon: 'money-collect',
          title: '非自营食堂收支',
          code: 'finance-non-self-support-income',
          requireAuth: true
        },
        component: resolve => {
          require(['../views/finance/non-self-support-income/index.vue'], resolve);
        }
      }
    ]
  },
  {
    path: '/bid',
    name: 'Bid',
    component: main,
    meta: {
      icon: 'file-search',
      title: '招投标信息',
      code: 'bid',
      requireAuth: true
    },
    children: [
      {
        path: 'projects',
        name: 'BidProjects',
        meta: {
          icon: 'project',
          title: '项目信息',
          code: 'bid-projects',
          requireAuth: true
        },
        component: resolve => {
          require(['../views/bid/projects/index.vue'], resolve);
        }
      },
      {
        path: 'experts',
        name: 'BidExperts',
        meta: {
          icon: 'team',
          title: '评标专家',
          code: 'bid-experts',
          requireAuth: true
        },
        component: resolve => {
          require(['../views/bid/experts/index.vue'], resolve);
        }
      },
      {
        path: 'bulkPurchase',
        name: 'BidBulkPurchase',
        meta: {
          icon: 'shopping',
          title: '大宗物品采购',
          code: 'bid-bulk-purchase',
          requireAuth: true
        },
        component: resolve => {
          require(['../views/bid/bulk-purchase/index.vue'], resolve);
        }
      }
    ]
  },
  {
    path: '/safety',
    name: 'Safety',
    component: main,
    meta: {
      icon: 'safety-certificate',
      title: '食安数据',
      code: 'safety',
      requireAuth: true
    },
    children: [
      {
        path: 'openKitchen',
        name: 'SafetyOpenKitchen',
        meta: {
          icon: 'video-camera',
          title: '明厨亮灶',
          code: 'safety-open-kitchen',
          requireAuth: true
        },
        component: resolve => {
          require(['../views/safety/open-kitchen/index.vue'], resolve);
        }
      },
      {
        path: 'foodSamples',
        name: 'SafetyFoodSamples',
        meta: {
          icon: 'container',
          title: '留样记录',
          code: 'safety-food-samples',
          requireAuth: true
        },
        component: resolve => {
          require(['../views/safety/food-samples/index.vue'], resolve);
        }
      },
      {
        path: 'morningChecks',
        name: 'SafetyMorningChecks',
        meta: {
          icon: 'schedule',
          title: '晨检记录',
          code: 'safety-morning-checks',
          requireAuth: true
        },
        component: resolve => {
          require(['../views/safety/morning-checks/index.vue'], resolve);
        }
      },
      {
        path: 'disinfection',
        name: 'SafetyDisinfection',
        meta: {
          icon: 'medicine-box',
          title: '消毒记录',
          code: 'safety-disinfection',
          requireAuth: true
        },
        component: resolve => {
          require(['../views/safety/disinfection/index.vue'], resolve);
        }
      },
      {
        path: 'accompanyMeal',
        name: 'SafetyAccompanyMeal',
        meta: {
          icon: 'usergroup-add',
          title: '陪餐记录',
          code: 'safety-accompany-meal',
          requireAuth: true
        },
        component: resolve => {
          require(['../views/safety/accompany-meal/index.vue'], resolve);
        }
      },
      {
        path: 'waste',
        name: 'SafetyWaste',
        meta: {
          icon: 'delete',
          title: '废弃物记录',
          code: 'safety-waste',
          requireAuth: true
        },
        component: resolve => {
          require(['../views/safety/waste/index.vue'], resolve);
        }
      }
    ]
  },
  {
    path: '/system',
    name: 'System',
    component: main,
    meta: {
      icon: 'setting',
      title: '系统管理',
      code: 'system',
      requireAuth: true
    },
    children: [
      {
        path: 'schoolList',
        name: 'schoolList',
        meta: {
          icon: 'bank',
          title: '学校管理',
          code: 'system-school',
          requireAuth: true,
          cacheName: 'SchoolList'
        },
        component: resolve => {
          require(['../views/sys/school/index.vue'], resolve);
        }
      },
      {
        path: 'userList',
        name: 'userList',
        meta: {
          icon: 'user',
          title: '用户管理',
          code: 'system-user',
          requireAuth: true,
          cacheName: 'UserList'
        },
        component: resolve => {
          require(['../views/sys/user/index.vue'], resolve);
        }
      },
      {
        path: 'depts',
        name: 'SystemDepts',
        meta: {
          icon: 'apartment',
          title: '区域管理',
          code: 'system-depts',
          requireAuth: true,
          cacheName: 'SystemDepts'
        },
        component: resolve => {
          require(['../views/system/depts/index.vue'], resolve);
        }
      },
      {
        path: 'roles',
        name: 'SystemRoles',
        meta: {
          icon: 'team',
          title: '角色管理',
          code: 'system-roles',
          requireAuth: true
        },
        component: resolve => {
          require(['../views/system/roles/index.vue'], resolve);
        }
      },
      {
        path: 'menus',
        name: 'SystemMenus',
        meta: {
          icon: 'menu',
          title: '菜单管理',
          code: 'system-menus',
          requireAuth: true,
          cacheName: 'SystemMenus'
        },
        component: resolve => {
          require(['../views/system/menus/index.vue'], resolve);
        }
      },
      {
        path: 'profile',
        name: 'SystemProfile',
        meta: {
          icon: 'user',
          title: '个人中心',
          code: 'system-profile',
          requireAuth: true,
          hideInMenu: true,
          keepAlive: false
        },
        component: resolve => {
          require(['../views/system/profile/index.vue'], resolve);
        }
      },
      {
        path: 'accounts',
        name: 'SystemAccounts',
        meta: {
          icon: 'user',
          title: '账号管理',
          code: 'system-accounts',
          requireAuth: true,
          hideInMenu: true
        },
        component: resolve => {
          require(['../views/system/accounts/index.vue'], resolve);
        }
      },
      {
        path: 'exportList',
        name: 'SystemExportList',
        meta: {
          icon: 'download',
          title: '任务中心',
          code: 'system-export-list',
          requireAuth: true,
          hideInMenu: true,
          cacheName: 'SystemExportList'
        },
        component: resolve => {
          require(['../views/system/export-list/index.vue'], resolve);
        }
      },
      {
        path: 'logs',
        name: 'SystemLogManage',
        redirect: {
          name: 'SystemOperLogs'
        },
        meta: {
          icon: 'profile',
          title: '日志管理',
          code: 'system-logs',
          requireAuth: true,
          cacheName: 'SystemLogs'
        },
        component: RouteView,
        children: [
          {
            path: 'oper',
            name: 'SystemOperLogs',
            meta: {
              icon: 'file-text',
              title: '操作日志',
              code: 'system-oper-logs',
              requireAuth: true,
              cacheName: 'SystemOperLogs',
              logType: 'oper'
            },
            component: resolve => {
              require(['../views/system/logs/index.vue'], resolve);
            }
          },
          {
            path: 'login',
            name: 'SystemLoginLogs',
            meta: {
              icon: 'login',
              title: '登录日志',
              code: 'system-login-logs',
              requireAuth: true,
              cacheName: 'SystemLoginLogs',
              logType: 'login'
            },
            component: resolve => {
              require(['../views/system/logs/index.vue'], resolve);
            }
          }
        ]
      },
      {
        path: 'auditList',
        name: 'auditList',
        meta: {
          icon: 'profile',
          title: '日志记录',
          code: 'system-audit',
          requireAuth: true,
          cacheName: 'AuditList',
          hideInMenu: true
        },
        component: resolve => {
          require(['../views/sys/audit/index.vue'], resolve);
        }
      }
    ]
  },
  {
    path: '*',
    redirect: '/404',
    meta: {
      hideInMenu: true,
      requireAuth: false
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/router.js